export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8583.cf460c81.jpg";